import type { PartnerBusiness } from '@pulsify/shared/dto'

interface PartnerCsvLabels {
  business: string
  signedUp: string
  assigned: string
  plan: string
  active: string
  lunchMenus: string
  menuScans: string
  events: string
  yes: string
  no: string
}

function cell(value: string | number): string {
  const text = String(value)
  const guarded = /^[=+\-@\t\r]/.test(text) ? `'${text}` : text
  return /[",;\n\r]/.test(guarded) ? `"${guarded.replaceAll('"', '""')}"` : guarded
}

/** The businesses of a partner as CSV, one row each, dates as YYYY-MM-DD. */
export function partnerBusinessesCsv(rows: PartnerBusiness[], labels: PartnerCsvLabels): string {
  const header = [
    labels.business,
    labels.signedUp,
    labels.assigned,
    labels.plan,
    labels.active,
    labels.lunchMenus,
    labels.menuScans,
    labels.events,
  ]
  const lines = rows.map((row) => [
    row.companyName,
    row.signedUpAt.slice(0, 10),
    row.referredAt?.slice(0, 10) ?? '',
    row.subscriptionTier,
    row.active ? labels.yes : labels.no,
    row.lunchMenus,
    row.menuScans,
    row.eventsPublished,
  ])
  return [header, ...lines].map((line) => line.map(cell).join(',')).join('\r\n')
}
